<template>
<div class="l_walk_through">
  <div id="container-holder" class="fade-in">
    <carousel
      class="vueCarousel-slide"
      :perPage="1"
      :paginationActiveColor="'#ba2121'"
      :paginationPosition="'bottom'"
      @page-change="pageChange"
      :paginationPadding="2"
      :value="numberPage"
      :paginationColor="'#E8C3B8'"
      :navigateTo="initialized ? null : [0, false]"
    >
      <slide>
        <div class="content-item c_slide__1" :class="{ is_ipad: isIPad }">
          <img :src="require('@/assets/img/walk-through/WT-01_1125.png')" alt="ico_setting" />
        </div>
      </slide>
      <slide>
        <div class="content-item c_slide__1" :class="{ is_ipad: isIPad }">
          <img :src="require('@/assets/img/walk-through/WT-02_1125.png')" alt="ico_setting" />
        </div>
      </slide>
      <slide>
        <div class="content-item c_slide__1" :class="{ is_ipad: isIPad }">
          <img :src="require('@/assets/img/walk-through/WT-03_1125.png')" alt="ico_setting" />
        </div>
      </slide>
      <slide>
        <div class="content-item c_slide__1" :class="{ is_ipad: isIPad }">
          <img :src="require('@/assets/img/walk-through/WT-04_1125.png')" alt="ico_setting" />
        </div>
      </slide>
    </carousel>
    <template v-if="parseInt(numberPage, 10) === 0">
      <div class="txt-container">
        <!-- <p class="paragraph">全国の香の川製麺がもっと楽しく!</p> -->
        <p class="paragraph">
          全国の香の川製麺で<br />スタンプをためて<br />クーポンをGet!
        </p>
      </div>
    </template>
    <template v-else-if="parseInt(numberPage, 10) === 1">
      <div class="txt-container">
        <p class="paragraph">
          スタンプを<br />たくさんためると<br />ランクアップ＆豪華特典も★
        </p>
      </div>
    </template>
    <template v-else-if="parseInt(numberPage, 10) === 2">
      <div class="txt-container">
        <p class="paragraph">
          来店履歴やプロフィールに応じた<br />あなただけの<br />特別なクーポンも登場♪
        </p>
      </div>
    </template>
    <template v-else>
      <div class="txt-container">
        <p class="paragraph">
          自動でスタンプを受け取るため<br />
          位置情報を「常に許可」に<br />
          設定してください<br />
        </p>
      </div>
    </template>
    <div class="button-action">
      <button @click="nextPage()" class="button-text">
        {{ this.buttonLabel }}
      </button>
    </div>
  </div>
</div>
</template>

<script>
// Source: https://github.com/SSENSE/vue-carousel
// Doc: https://ssense.github.io/vue-carousel/guide/
import {
  Carousel,
  Slide
} from 'vue-carousel' // import slider components
import {
  mapActions
} from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
import '@/styles/color.css'

export default {
  name: 'WalkThrough',
  data() {
    return {
      numberPage: 0,
      isIPad: false,
      initialized: false
    }
  },
  computed: {
    buttonLabel: function () {
      return '次へ'
    }
  },
  mounted: function () {
    const ua = window.navigator.userAgent
    if (ua.indexOf('iPhone') >= 0 && window.innerWidth < 375) {
      this.isIPad = true
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    ...mapActions('Native', ['actionCallTermsOfService']),
    ...mapActions('Analytics', ['trackEvent']),
    // 利用規約を呼び出す
    async callTermsOfService() {
      try {
        this.trackEvent(FactoryTrack.createTermsOfService())
        this.actionCallTermsOfService()
      } catch (e) {
        console.warn(e)
      }
    },

    nextPage() {
      this.initialized = true
      this.numberPage += 1
      if (parseInt(this.numberPage) === 4) {
        this.trackEvent(FactoryTrack.createToRegistration())
        this.$router.push('registration')
      } else {
        this.trackEvent(FactoryTrack.createNextPage('ウォークスルー', this.numberPage))
      }
    },
    pageChange(data) {
      this.initialized = true
      this.trackEvent(FactoryTrack.createPageChange('ウォークスルー', this.numberPage))
      this.numberPage = data
    }
  }
}
</script>

<style lang="scss" scoped>
#app.isFixed {
  position: relative;
}

.l_walk_through {
  background-color: var(--background-color);
  min-height: 100%;
  overflow-y:hidden ;
  position: relative;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}

.l_walk_through #container-holder {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.c_slide__1 {
  background-repeat: no-repeat;
  background-size: cover;

  img {
    width: 100%;
    height: 100%;

    &.fourth {
      width: 80%;
    }
  }
}

.c_link {
  text-decoration: underline;
}

.fourth-text {
  padding: 5px 30px;
  font-size: 0.7em;
}

.is_ipad {
  padding: 30px 30px 0;
}

.l_walk_through .oval {
  width: 282px;
  height: 282px;
  display: inline-block;
  background-color: #eeeeee;
  border-radius: 50%;
}

.l_walk_through .txt-container {
  margin-top: 15px;
}

.l_walk_through .txt-container .paragraph {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #333333;
}

.l_walk_through .txt-container .content {
  font-size: 12px;
  line-height: 1.67;
  text-align: center justify;
  color: #333333;
}

.l_walk_through .content-item .circle {
  width: 36px;
  margin: 0 auto;
  display: inline-block;
  margin-top: 32px;
}

.l_walk_through .content-item .circle div {
  width: 7px;
  height: 7px;
  background-color: #cccccc;
  border-radius: 4px;
  display: inline-block;
  margin-left: 5px;
}

.l_walk_through .content-item .circle div:nth-child(2) {
  background-color: #602209;
}

.l_walk_through .button-action {
  padding: 0px 30px;
  display: inline-block;
  margin-top: 19px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  color: #ffffff;
  width: 100%;
}

.l_walk_through .button-action .button-text {
  width: 100%;
  background: var(--accent-color);
  border-radius: 7px;
  border: none;
  font-weight: bold;
  padding: 13px 2px;
  color: #ffffff;
}

@keyframes fadeIn{
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.75s ease-out 0.05s forwards;
}

@media only screen and (max-width: 320px) {
  .l_walk_through .txt-container .paragraph {
    font-size: 17px;
  }

  .l_walk_through .txt-container .content {
    font-size: 11px;
  }
}
</style>
